import { render } from "./SubpageEvents.vue?vue&type=template&id=44c1b874&scoped=true"
import script from "./SubpageEvents.vue?vue&type=script&lang=js"
export * from "./SubpageEvents.vue?vue&type=script&lang=js"

import "./SubpageEvents.vue?vue&type=style&index=0&id=44c1b874&lang=scss&scoped=true"

import exportComponent from "/__w/system/system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44c1b874"]])

export default __exports__